import { addCourseOffer } from '../services/courseOfferService';
import { addUnitOffer } from '../services/unitOfferService';

export const setCourseOffer = (courseOffer) => ({
  type: 'SET_COURSE_OFFER',
  courseOffer,
});

export const setLoading = (loading) => ({
  type: 'SET_LOADING',
  loading,
});

export const setSubmitSuccess = (success) => ({
  type: 'SET_SUBMIT_SUCCESS',
  success,
});

export const setSubmitErrors = (errors) => ({
  type: 'SET_SUBMIT_ERRORS',
  errors,
});

export const setCurrentCourseOffer = (courseOffer) => {
  return (dispatch) => {
    dispatch(setCourseOffer(courseOffer));
  };
};

export const setCurrentCloneCourseOffer = (courseOffer, unitOffers) => {
  return async (dispatch) => {
    const formattedCourseOffer = {
      ...courseOffer,
      startDate: courseOffer.startDate.utc().format(),
      endDate: courseOffer.endDate.utc().format(),
    };
    // Remove id field
    delete formattedCourseOffer._id;
    delete formattedCourseOffer.courseOfferId;

    const errors = [];
    const success = [];
    dispatch(setLoading(true));
    try {
      await addCourseOffer(formattedCourseOffer).then(async (response) => {
        const newCourseOffer = response.data.courseOffer;
        const formattedUnitOffer = unitOffers.map((unitOffer) => {
          return {
            isActive: unitOffer.isActive,
            code: unitOffer.code,
            startDate: unitOffer.startDate,
            endDate: unitOffer.endDate,
            unitId: unitOffer.unitId,
            maxRegistrations: unitOffer.maxRegistrations,
            minRegistrations: unitOffer.minRegistrations,
            courseOfferId: newCourseOffer.courseOfferId,
          };
        });
        success.push({
          message: `Created course offer ${newCourseOffer.code}`,
        });
        // Processing in sequence
        for (const unitOffer of formattedUnitOffer) {
          await addUnitOffer(unitOffer)
            .then(async (res) => {
              success.push({
                message: `Created unit offer ${unitOffer.code}`,
              });
              // Add a timeout to avoid choking request
              await new Promise((r) => setTimeout(r, 500));
            })
            .catch((err) => {
              errors.push({
                message: `Failed to create unit offer ${unitOffer.code}`,
                err: err,
              });
            });
        }
        dispatch(setSubmitErrors(errors));
        dispatch(setSubmitSuccess(success));
        dispatch(setLoading(false));
        window.location.replace(
          `/course-offer/${newCourseOffer.courseOfferId}`
        );
      });
    } catch (e) {
      errors.push({
        message: `Failed to create course offer ${formattedCourseOffer.code}`,
        err: e,
      });
      dispatch(setSubmitErrors(errors));
      dispatch(setLoading(false));
    }
  };
};
